export default __webpack_public_path__ + "24650f2bb08020ae0b32fb90b1e9f54d.svg";